/* eslint-disable no-undef */
import { markRaw } from 'vue';
export default {
	name: "dashboard",
	data() {
		return {
			customers: [],
			years: [],
			months: [],
			selectedStartDate: null,
			selectedEndDate: null,
			selectedMonth: {
				name: null,
				id: null
			},
			selectedYear: null,
			selectedOrderType: null,
			orderTypes: [],
			barChartXAxisName: null,
			customerSignUpsPerMonthData: {},
			totalVolumePurchasedPerProductMonthlyData: {},
			customerSignUpsPerMonthChart: null,
			totalVolumePurchasedPerProductMonthlyChart: null,
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null,
			firstLoad: false,
			productVolumePerDayChart: null,
			productPricePerDayChart: null,
			hideClearButton: true,
			initialiseDatePicker: true,
			initialiseDatePickerEndDate: true,
			startDateHasChanged: false,
			endDateHasChanged: false,
			errorModal:{
				showModal: false,
				errorMessage: null
			}
		};
	},
	methods: {
		getReportYearsAndMonths() {
			//this.loading = true;
			reportService.getReportYearsAndMonths().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//this.years = successResponse.data.years;
						var self = this;
						this.selectedStartDate = successResponse.data.beginningOfCurrentMonth;
						this.selectedEndDate = successResponse.data.endOfCurrentMonth;
						// setTimeout(() => {
						// 	self.selectedStartDate = successResponse.data.beginningOfCurrentMonth;
						// 	self.selectedEndDate = successResponse.data.endOfCurrentMonth;
						// }, 500);
						this.months = successResponse.data.months;

						this.months = $.map(this.months,
							function (obj) {
								obj.id = obj.id || obj.month;
								obj.text = obj.text || obj.name;
								return obj;
							}
						);

						for(let i = 0; i < successResponse.data.years.length; i++){
							let yearObj = {
								id: successResponse.data.years[i],
								text: successResponse.data.years[i].toString()
							};
							this.years.push(yearObj);
						}
						
						// this.years = $.map(this.years,
						// 	function (obj) {
						// 		obj.id =obj;
						// 		obj.text = obj;
						// 		return obj;
						// 	}
						// );
						// this.selectedMonth.id = successResponse.data.currentMonth;
						// this.selectedMonth.name = successResponse.data.currentMonthName;
						this.selectedYear = successResponse.data.currentYear;
						this.getDashboard();
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDashboard() {
			//this.loading = true;
			let request = {
				year: this.selectedYear,
			}
			reportService.getDashboardSummary(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerSignUpsPerMonthData = successResponse.data.customerSignUpsPerMonth;
						this.totalVolumePurchasedPerProductMonthlyData = successResponse.data.totalVolumePurchasedPerProductMonthly;
						console.log("customerSignUpsPerMonthData", this.customerSignUpsPerMonthData);
						var self = this;
						setTimeout(() => {
							if(self.customerSignUpsPerMonthData !== null && self.customerSignUpsPerMonthData !== undefined){
								self.buildCustomerSignUpsPerMonthChart();
							}
							if(this.totalVolumePurchasedPerProductMonthlyData !== null && this.totalVolumePurchasedPerProductMonthlyData !== undefined){
								self.buildTotalVolumePurchasedPerProductMonthlyChart();
							}
						}, 1000);

						this.firstLoad = true;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onErrorModalOkClicked(){
			this.errorModal.showModal = false;
		},
		downloadNewSignUpReport(){
			this.loading = true;
			let request = {
				startDate: this.selectedStartDate,
				endDate: this.selectedEndDate
			};
			reportService.downloadCustomerSignUpsReport(request).then(
				response => {
					console.log("successResponse", response);
					if(response.status === 200){
						console.log("successResponse", response);
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'CustomerSignUpsReport.csv');
						document.body.appendChild(link);
						link.click();
						this.loading = false;
					}
					if(response.status === 400){
						console.log("errorResponse", response);
						this.errorModal.showModal = true;
						this.errorModal.errorMessage = "No report found for selected date range";
					}
				}
			);	
		},
		downloadDetailTransactionReport(){
			this.loading = true;
			let request = {
				startDate: this.selectedStartDate,
				endDate: this.selectedEndDate
			};
			reportService.downloadDetailedCustomerTransactionsReport(request).then(
				response => {
					console.log("successResponse", response);
					if(response.status === 200){
						console.log("successResponse", response);
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'DetailedCustomerTransactionsReport.csv');
						document.body.appendChild(link);
						link.click();
						this.loading = false;
					}
					if(response.status === 400){
						this.errorModal.showModal = true;
						this.errorModal.errorMessage = "No report found for selected date range";
					}
				}
			);
		},
		downloadCustomerPointsBalanceReport(){
			this.loading = true;
			let request = {
				startDate: this.selectedStartDate,
				endDate: this.selectedEndDate
			};
			reportService.downloadCustomerPointBalancesReport(request).then(
				response => {
					console.log("successResponse", response);
					if(response.status === 200){
						console.log("successResponse", response);
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'CustomerPointBalancesReport.csv');
						document.body.appendChild(link);
						link.click();
						this.loading = false;
					}
					if(response.status === 400){
						this.errorModal.showModal = true;
						this.errorModal.errorMessage = "No report found for selected date range";
					}
				}
			);
		},
		downloadCustomerEarningAndRedeemingFrequencyReport(){
			this.loading = true;
			let request = {
				startDate: this.selectedStartDate,
				endDate: this.selectedEndDate
			};
			reportService.downloadCustomerEarningAndRedeemingFrequencyReport(request).then(
				response => {
					console.log("successResponse", response);
					if(response.status === 200){
						console.log("successResponse", response);
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'CustomerEarningAndRedeemingFrequencyReport.csv');
						document.body.appendChild(link);
						link.click();
						this.loading = false;
					}
					if(response.status === 400){
						this.errorModal.showModal = true;
						this.errorModal.errorMessage = "No report found for selected date range";
					}
				}
			);
		},
		buildCustomerSignUpsPerMonthChart() {
			console.log("customerSignUpsPerMonthData", this.customerSignUpsPerMonthData);
			var option = {
				tooltip: {
					
				},
				xAxis: {
					type: 'category',
					data: this.customerSignUpsPerMonthData.xAxisLabels,
					name: this.customerSignUpsPerMonthData.xAxisTitle
				},
				yAxis: {
					type: 'value',
					name: this.customerSignUpsPerMonthData.yAxisTitle
				},
				series: [
					{
						data: this.customerSignUpsPerMonthData.yAxisValues,
						type: 'bar'
					}
				]
			};
			console.log("option", option);
			if(this.customerSignUpsPerMonthChart === null){
				this.customerSignUpsPerMonthChart = markRaw(window.echarts.init(document.getElementById("customerSignUpsPerMonthChart"), theme));
			}
			this.customerSignUpsPerMonthChart.setOption(option, true);
			this.resizeEventForChart(this.customerSignUpsPerMonthChart);
		},
		buildTotalVolumePurchasedPerProductMonthlyChart() {
			let sourceData = [];
			let numberBars = this.totalVolumePurchasedPerProductMonthlyData.dimensions.length - 1;
			let series = [];
			for(let i = 0; i < this.totalVolumePurchasedPerProductMonthlyData.series.length; i++) {
				let sourceDataRow = [];
				let xAxisHeading = this.totalVolumePurchasedPerProductMonthlyData.series[i].name;
				sourceDataRow.push(xAxisHeading);
				for(let j = 0; j < this.totalVolumePurchasedPerProductMonthlyData.series[i].values.length; j++) {
					sourceDataRow.push(this.totalVolumePurchasedPerProductMonthlyData.series[i].values[j]);
				}
				sourceData.push(sourceDataRow);
			}
			for(let k = 0; k < numberBars; k++){
				series.push({ type: 'bar' });
			}
				
			console.log("sourceData", sourceData);
			let option = {
				legend: {},
				tooltip: {},
				dataset: {
					dimensions: this.totalVolumePurchasedPerProductMonthlyData.dimensions,
					source: sourceData
				},
				xAxis: {
					name: "Months",
					type: 'category'
				},
				yAxis: {
					type: "value",
					name: 'Litres'
				},
				// Declare several bar series, each will be mapped
				// to a column of dataset.source by default.
				series: series
			};
			if(this.totalVolumePurchasedPerProductMonthlyChart === null){
				this.totalVolumePurchasedPerProductMonthlyChart = markRaw(window.echarts.init(document.getElementById("totalVolumePurchasedPerProductMonthlyData"), theme));
			}
			this.totalVolumePurchasedPerProductMonthlyChart.setOption(option, true);
			this.resizeEventForChart(this.totalVolumePurchasedPerProductMonthlyChart);
		},
		resizeEventForChart(chart) {
			window.addEventListener("resize", function () {
				if (chart != null && chart != undefined) {
					chart.resize();
				}
			});
		},
		onDateFilterClearClick(){
			this.selectedStartDate = null;
			this.selectedEndDate = null;
		},
		onFromDateCreatedSelect(date) {
			this.selectedStartDate = date;
			this.startDateHasChanged = true;
			this.initialiseDatePicker = false;
			// if(this.selectedStartDate !== null && this.selectedEndDate !== null && this.startDateHasChanged && this.endDateHasChanged){
			// 	// if(this.firstLoad){
			// 	// 	this.getDashboard();
			// 	// }
			// 	this.getDashboard();
			// }
		},
		onToDateCreatedSelect(date) {
			this.selectedEndDate = date;
			this.endDateHasChanged = true;
			this.initialiseDatePickerEndDate = false;
			// if(this.selectedStartDate !== null && this.selectedEndDate !== null){
			// 	// if(this.firstLoad){
			// 	// 	this.getDashboard();
			// 	// }
			// 	this.getDashboard();
			// }
		},
		onMonthSelect(month) {
			this.selectedMonth.id = month.id;
			this.selectedMonth.name = month.text;
			if(this.firstLoad){
				this.getDashboard();
			}
		},
		onYearSelect(year) {
			this.selectedYear = year.id;
			if(this.firstLoad){
				this.getDashboard();
			}
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Dashboard");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Dashboard");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		var self = this;
		setTimeout(function (){
			//self.getDashboard();
			self.getReportYearsAndMonths();
		}, 500);
		
		//this.getReportYearsAndMonths();
		// var self = this;
		// var sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
		// console.log("sevenDaysAgo", sevenDaysAgo);
		// var dateNow = new Date();
		// var firstDayOfMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
		// var lastDayOfMonth = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
		// console.log("firstDayOfMonth", firstDayOfMonth);
		// console.log("lastDayOfMonth", lastDayOfMonth);
		// setTimeout(() => {
		// 	self.selectedStartDate = sevenDaysAgo;
		// 	self.selectedEndDate = dateNow;
		// }, 500);
		//this.getDashboard();
	},
	unmounted: function () {
		if(this.customerSignUpsPerMonthChart !== null){
			this.customerSignUpsPerMonthChart.dispose();
		}
		if(this.totalVolumePurchasedPerProductMonthlyChart !== null){
			this.totalVolumePurchasedPerProductMonthlyChart.dispose();
		}
	}
};